import { NgClass, NgIf } from '@angular/common';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ErrorNotificationComponent } from '@components/error-notification/error-notification.component';
import { StdConsultationRequestFormComponent } from '@components/std-consultation-request-form/std-consultation-request-form.component';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { environment } from '@environments/environment';
import { LoadingService } from '@services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-consultation-request',
  templateUrl: './consultation-request.component.html',
  styleUrls: ['./consultation-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, NgClass, ErrorNotificationComponent, StdConsultationRequestFormComponent],
})
export class ConsultationRequestComponent implements OnInit {
  public errorMessage: string;
  protected readonly ConsultationTreatmentTypes = ConsultationTreatmentTypes;

  protected loadingService = inject(LoadingService);
  private activatedRoute = inject(ActivatedRoute);
  private titleService = inject(Title);

  /**
   * Gets the headline for the checkout page.
   *
   * @returns {string} the headline for the checkout page
   */
  public get headlineCheckout(): string {
    return environment.titles.headlineCheckoutScheduled;
  }

  /**
   * Gets the headline class from the config.
   *
   * @returns {string} the headline class
   */
  public get headlineClass(): string {
    return environment.styles.consultationRequest.headlineClass;
  }

  /**
   * Initializes the component.
   */
  public ngOnInit(): void {
    this.titleService.setTitle(environment.titles.consultationRequest);
    this.handleConsultationOrderDetails();
  }

  /**
   * Gets the consultation request order from the resolver and handles the error if any.
   *
   * @returns {Subscription} a Subscription to the resolver data
   */
  private handleConsultationOrderDetails(): Subscription {
    return this.activatedRoute.data.subscribe(({ consultationOrderDetails }) => {
      if (consultationOrderDetails?.error) {
        this.errorMessage = consultationOrderDetails.errorMessage;
      }

      this.loadingService.toggleLoader(false);
    });
  }
}
